import React from 'react'

export default function DonutChart({ data, title, size = 200 }) {
  const total = data.reduce((s, d) => s + d.value, 0)
  const radius = size * 0.32
  const strokeWidth = size * 0.09
  const center = size / 2
  const circumference = 2 * Math.PI * radius

  let cumulative = 0
  const segments = data.map(d => {
    const pct = total > 0 ? d.value / total : 0
    const seg = { ...d, pct, startOffset: cumulative * circumference }
    cumulative += pct
    return seg
  })

  return (
    <div style={{
      background: '#fff', borderRadius: 6, border: '1px solid #f0f0f0',
      padding: '20px 24px', display: 'flex', flexDirection: 'column', height: '100%'
    }}>
      {title && (
        <div style={{ fontSize: 16, fontWeight: 600, color: '#1a1a1a', marginBottom: 16 }}>{title}</div>
      )}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 32 }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle cx={center} cy={center} r={radius} fill="none" stroke="#f0f0f0" strokeWidth={strokeWidth} />
          {total > 0 && segments.map((seg, i) => (
            <circle
              key={i}
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke={seg.color}
              strokeWidth={strokeWidth}
              strokeDasharray={`${seg.pct * circumference} ${circumference}`}
              strokeDashoffset={circumference * 0.25 - seg.startOffset}
              transform={`rotate(-90 ${center} ${center})`}
              strokeLinecap="butt"
              style={{ transition: 'stroke-dasharray 0.6s ease' }}
            />
          ))}
          <text x={center} y={center} textAnchor="middle" dominantBaseline="central"
            fontSize={size * 0.13} fontWeight="bold" fill="#333" fontFamily="inherit">
            {total.toLocaleString()}
          </text>
        </svg>
        <div style={{ minWidth: 70 }}>
          {segments.map((seg, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, fontSize: 13 }}>
              <span style={{
                width: 10, height: 10, borderRadius: '50%', background: seg.color,
                display: 'inline-block', flexShrink: 0
              }} />
              <div>
                <div style={{ color: '#666', lineHeight: 1.2 }}>{seg.label}</div>
                {seg.value > 0 && (
                  <div style={{ color: '#999', fontSize: 11 }}>{seg.value.toLocaleString()}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
